import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getHistoricoAlunoGeral(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/termometro/geral/historico_aluno/', {params});
  return data;
}

type QueryFnType = typeof getHistoricoAlunoGeral;

function useHistoricoAlunoGeral(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-historico-aluno-geral', params],
    queryFn: () => getHistoricoAlunoGeral(params),
  });
}

export { getHistoricoAlunoGeral, useHistoricoAlunoGeral };
